import { useMemo } from 'react';

import useForm from '../utils/useForm';

const useBillComSettlementForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: 'Details',
        isTitleHidden: true,
        fields: [
          {
            title: 'Money Movement ID',
            name: 'moneymovement_id',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'ACH Confirmation ID',
            name: 'ach_confirmation_id',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Type',
            name: 'type',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Amount',
            name: 'amount',
            type: 'currency',
            readOnly: true,
          },
          {
            title: 'Process Date',
            name: 'process_date',
            type: 'date',
            readOnly: true,
          },
          {
            title: 'Status',
            name: 'status',
            type: 'text',
            readOnly: true,
          },
          {
            title: 'Bank Account',
            name: 'bankAccount',
            type: 'text',
            readOnly: true,
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit, values });
};

export default useBillComSettlementForm;
